function firstLabel(...values) {
    for (const value of values) {
        const label = typeof value === 'string' ? value.trim() : '';
        if (label)
            return label;
    }
    return null;
}
/**
 * Display the same customer the QBO document bills.
 * An explicit bill-to never falls back to the serviced customer.
 */
export function resolveTicketCustomerDisplayName(ticket) {
    const resolved = firstLabel(ticket.customer_display_name);
    if (resolved)
        return resolved;
    if (ticket.bill_to_customer_id != null || ticket.bill_to_customer != null) {
        return firstLabel(ticket.bill_to_customer?.display_name, ticket.bill_to_customer?.company_name, ticket.bill_to_customer_name, ticket.bill_to_customer_name_snapshot, ticket.bill_to_customer_id);
    }
    return firstLabel(ticket.customer?.display_name, ticket.customer?.company_name, ticket.customer_name, ticket.customer_name_snapshot, ticket.customer_id);
}
//# sourceMappingURL=ticketCustomer.js.map